import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { BlueprintVersionedGroup } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";

const TemplatesLatestVersionCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<BlueprintVersionedGroup>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{template.latestVersion?.version}</TableCellText>
    </TableSimpleCell>
  );
};

export default TemplatesLatestVersionCell;
